import { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { sanitizeRichTextHtml, isRichTextEmpty } from 'shared/utils/richText';
import { Color } from 'shared/utils/colors';

interface RichTextViewProps {
  content?: string;
  sx?: SxProps<Theme>;
  dataQa?: string;
}

export const RichTextView: FC<RichTextViewProps> = ({ content, sx, dataQa }) => {
  if (!content || isRichTextEmpty(content)) {
    return null;
  }

  const sanitized = sanitizeRichTextHtml(content);

  return (
    <Box
      data-qa={dataQa}
      sx={{
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        '& p': {
          margin: 0,
          marginBottom: 1,
          '&:last-child': {
            marginBottom: 0,
          },
        },
        '& ul, & ol': {
          paddingLeft: 3,
          margin: 0,
        },
        '& code': {
          backgroundColor: 'action.hover',
          padding: '2px 4px',
          borderRadius: '4px',
          fontFamily: 'monospace',
          fontSize: '0.875em',
        },
        '& a': {
          // Darkened primary for legible link text on light surfaces (WCAG 1.4.3).
          color: Color.primaryOrangeDark,
          textDecoration: 'underline',
          overflowWrap: 'break-word',
          wordBreak: 'break-all',
        },
        ...sx,
      }}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};

export default RichTextView;
